import { useEffect, useState } from 'react';
import { PosSpinner } from 'src/core/POS/PosSpinner';

import { ChartHeaderInput } from '../ChartHeader';
import * as styles from '../DataInsightsChart.css';
import { SaleChartData, useDataInsights } from '../DataInsightsContext';
import { DataLineChart } from '../LineChart/DataLineChart';
import { TargetInput } from '../TargetInput';
import { TimePeriodSelector } from '../TimePeriodSelector';

export const RevenueChart = ({
  data,
  renderHeader,
}: {
  data: SaleChartData[] | null;
  renderHeader: (input: ChartHeaderInput) => JSX.Element;
}) => {
  const {
    uiCurrency,
    targetValue,
    setTargetValue,
    paddedChartData,
    isScrolling,
    isLoading,
  } = useDataInsights();

  const [revenueValue, setRevenueValue] = useState<number | null>(
    data && data.length > 0 ? data[data.length - 1].totalRevenue : null
  );

  useEffect(() => {
    if (data && data.length > 0) {
      setRevenueValue(data[data.length - 1].totalRevenue);
    }
  }, [data]);

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: uiCurrency.code,
  });

  return (
    <>
      {renderHeader({
        subtitle: targetValue
          ? `${revenueValue || 0 > targetValue ? '+' : '-'}
        ${currencyFormatter.format(Math.abs(revenueValue || 0 - targetValue))} vs Target`
          : '',
        value: revenueValue,
        isScrolling,
        prefix: uiCurrency.sym,
      })}

      <DataLineChart
        data={data}
        paddedData={paddedChartData}
        setValue={setRevenueValue}
        valueKey="totalRevenue"
      />
      <TimePeriodSelector />

      <TargetInput targetValue={targetValue} setTargetValue={setTargetValue} />
    </>
  );
};
